import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';
import { GeometryAABBUpdater } from './interfaces';
import { Shape } from '../../types';

var LineUpdater =
/** @class */
function () {
  function LineUpdater() {}

  LineUpdater.prototype.update = function (parsedStyle) {
    var x1 = parsedStyle.x1,
        y1 = parsedStyle.y1,
        x2 = parsedStyle.x2,
        y2 = parsedStyle.y2;
    var minX = Math.min(x1, x2);
    var maxX = Math.max(x1, x2);
    var minY = Math.min(y1, y2);
    var maxY = Math.max(y1, y2);
    var width = maxX - minX;
    var height = maxY - minY;
    return {
      width: width,
      height: height,
      x: minX,
      y: minY
    };
  };

  LineUpdater = __decorate([singleton({
    token: {
      token: GeometryAABBUpdater,
      named: Shape.LINE
    }
  })], LineUpdater);
  return LineUpdater;
}();

export { LineUpdater };